import buildImageSrc from '../functions/image-functions-aspect-ratio';

interface Props {
  src: string;
  width: number;
  quality?: number;
}

const imageLoader = ({ src, width, quality }: Props) => {
  return buildImageSrc(null, width, null, null, src, quality);
};

export default imageLoader;
